import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { HeaderItem } from '../types'
import { LinkTab } from './LinkTab'
import { samePageLinkNavigation } from './utils'

interface NavTabsProps {
  headerLinks: HeaderItem[]
}

export const NavTabs: React.FC<NavTabsProps> = ({ headerLinks }) => {
  const [value, setValue] = useState(0)
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.includes('organization-settings')) return
    const activeIndex = headerLinks.findIndex(
      (item) =>
        item.to === location.pathname ||
        item.children?.some((child) => location.pathname.includes(child.path))
    )
    activeIndex !== -1 && setValue(activeIndex)
  }, [headerLinks, location.pathname])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (
      event.type !== 'click' ||
      (event.type === 'click' &&
        samePageLinkNavigation(event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>))
    ) {
      setValue(newValue)
    }
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="navigation"
        role="navigation"
        slotProps={{
          root: {
            sx: {
              justifyContent: 'space-between',
            },
          },
        }}
      >
        {headerLinks.map((item, index) => (
          <LinkTab
            key={item.name}
            label={item.name}
            to={item.to}
            selected={value === index}
            href={item.to}
            children={item.children}
          />
        ))}
      </Tabs>
    </Box>
  )
}
